/** @module powerReviewsService - it is used to render the Power reviews inside the Product details page.*/
define([
    'require',
    'jquery',
    'pubsub'
], function(require, $, pubsub) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'powerReviewsService';
    var DEBUG = false;
    var enableProductSchemaInPowerReviewsJSON =  WCS_CONFIG.get('PDP::enableProductSchemaInPowerReviewsJSON') || false;
    var productVariantIdEnabled =  WCS_CONFIG.get('PDP::productVariantIdEnabled') || false;
    var pdpPRContainerArrowsLogicEnabled = WCS_CONFIG.get("PDP::pdpPRContainerArrowsLogicEnabled") || false;
    var qaShowNumberOfQuestions = false;
    var stlWidgetModalOpened = false
// Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function() {
            var self = this;

            if (DEBUG) console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );
            qaShowNumberOfQuestions = self.config.qaShowNumberOfQuestions;

            // Initialize events
            self.events();
            self.initHandlePRContainerArrows();

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        initHandlePRContainerArrows: function() {
           var self = this;
           if (pdpPRContainerArrowsLogicEnabled) {     
                $.pubsub('subscribe', 'vfdp.wcs.product_reviews.loaded', function() {
                    if ( DEBUG ) console.log('vfdp.wcs.product_reviews.loaded');
                    self.handlePRContainerArrows();
                });
            }
        },

        handlePRContainerArrows: function () {
            if ( DEBUG ) console.log('handlePRContainerArrows');
            try {
                var isPrIrlSnippetLoaded = false;
                var waitForPowerReviews = setInterval(function() {
                    var $prImagesCount = $('#pr-review-snapshot .pr-irlsnippet button.pr-irlsnippet-image-container').length;
                    var $prImageWidth = $('#pr-review-snapshot .pr-irlsnippet button.pr-irlsnippet-image-container').width();
                    var $prAllImagesWidth;
                    if ($prImagesCount && $prImageWidth) {
                        $prAllImagesWidth = $prImageWidth * $prImagesCount;

                        if (!isPrIrlSnippetLoaded) {
                         isPrIrlSnippetLoaded = true;
                        }
                    }

                    if ($prAllImagesWidth && $prAllImagesWidth <= window.innerWidth) {
                        $('#pr-review-snapshot .pr-irlsnippet .pr-irlsnippet-leftbtn').hide();
                        $('#pr-review-snapshot .pr-irlsnippet .pr-irlsnippet-rightbtn').hide();
                    }

                    if (isPrIrlSnippetLoaded) {
                        clearInterval(waitForPowerReviews);
                    }
                },100);
            } catch(err) {
                console.log(err);
            }
        },

        initPowerReviews: function (components) {
            if (DEBUG) console.log('initPowerReviews');

            var self = this;
            self.powerReviewsConfig = [];
            self.hasFullview = false;
            if (self.config.prDisplay4URL) {
                if ("fullview" in components) {
                    self.hasFullview = true;
                    self._setPowerReviewsFullviewConfiguration();
                }

                $.each(components, function (componentName, id) {
                    if (componentName !== "fullview" && (!id || $('#' + id).length > 0)) {
                        self._setPowerReviewsComponentConfiguration(componentName, id);
                    }
                });

                self._renderPowerReviewsComponents();
            } else {
                // only full view available
                self.initPowerReviewsOldVersion();
            }
        },

        initPowerReviewsOldVersion: function (libUrl) {
            if (DEBUG) console.log('initPowerReviewsOldVersion');
            var self = this;
            libUrl = (libUrl === '' || libUrl ?  libUrl : 'pwr/engine/js/full.js');

            require([self.config.pwrDir + libUrl], function () {
                POWERREVIEWS.display.engine({
                        write: function (content) {
                            $("div#rating_reviews").append(content);
                            $("div#rating_reviews  div.pr-review-engine div[itemtype='http://schema.org/Product']").removeAttr("itemtype").removeAttr("itemscope");
                        }
                    },
                    {
                        pr_page_id: self.config.prPageID,
                        pr_write_review: self.config.writeReviewUrl
                    }
                );

                if (self.config.qaEnabled) {
                    self.initQuestionsAnswers();
                }

                if (self.config.whyDidYouBuyProd){
                    self.initWhyDidYouBuy();
                }

            });
        },

        /**
         *  Arrange the display of the extended view of PowerReviews - usually at the bottom of a PDP
         */
        _setPowerReviewsFullviewConfiguration: function () {
            if (DEBUG) console.log('_setPowerReviewsFullviewConfiguration');
            var self = this;
            var powerReviewsConfig = self._getPowerReviewsGlobalConfiguration();

            $.extend(powerReviewsConfig,
                self._getPowerReviewsElementConfiguration(),
                self._getPowerReviewsFullviewFeatureConfiguration()
            );

            self.powerReviewsConfig.push(powerReviewsConfig);
        },

        /**
         *  Arrange the display of a snippet from Power Reviews.
         *  If the vfdp-data is attached to the star rating element, then the input id can be omitted.
         *  If the vfdp-data is attached to another element, typically in PDP page where the full view of
         *  PowerReviews is shown, the input id must be passed.
         */
        _setPowerReviewsComponentConfiguration: function (componentName, id) {
            if (DEBUG) console.log('_setPowerReviewsComponentConfiguration');
            var self = this,
                $rootElement,
                powerReviewsConfig = self._getPowerReviewsGlobalConfiguration();

            if (id) {
                $rootElement = $('#' + id);
            } else {
                $rootElement = $(self.element);
                id = $rootElement.prop('id');
            }

            if (id) {
                var $targetElements = $('[id^=' + id + '-' + componentName.toLowerCase() + '-]');

                // if no $targetElements, then only the element to which the module invocation is attached is involved
                if ($targetElements.length === 0) {
                    if (self.hasFullview === true) {
                        // if there is fullview it's always the first component to be handled
                        self.powerReviewsConfig[0].components[componentName] = id;
                    } else {
                        $.extend(powerReviewsConfig, self._getPowerReviewsElementConfiguration());
                        powerReviewsConfig.components[componentName] = id;
                        self.powerReviewsConfig.push(powerReviewsConfig);
                    }
                } else {
                    $targetElements.each(function () {
                        var $targetElement = $(this);

                        if ($targetElement.children(".p-w-r").length === 0) {
                            var targetElementData = $targetElement.data();
                            self.config.prPageID = targetElementData.powerReviewsServiceOptionPrPageId;
                            self.config.writeReviewUrl = targetElementData.powerReviewsServiceOptionWriteReviewUrl;

                            var powerReviewsComponentConfig = $.extend(true, {}, powerReviewsConfig, self._getPowerReviewsElementConfiguration());
                            powerReviewsComponentConfig.components[componentName] = $targetElement.attr('id');
                            self.powerReviewsConfig.push(powerReviewsComponentConfig);
                        }
                    });
                }

                if (componentName === 'ReviewSnippet') {
                    $.pubsub('subscribe', 'vfdp.wcs.product_reviews.loaded', self._setReviewSnippetLayout.bind($rootElement));
                }
            }
        },

        _getPowerReviewsGlobalConfiguration: function() {
            if (DEBUG) console.log('_getPowerReviewsGlobalConfiguration');
            var self = this,
                productVariantIdTag = $('[name="productCode"]'),
                productVariantId = null;

            if (productVariantIdEnabled) {
                productVariantId =  productVariantIdTag.length ? productVariantIdTag.val() : null;
            }

            return {
                api_key: self.config.prAPIKey,
                locale: self.config.prLocale,
                merchant_group_id: self.config.merchantGroupId,
                merchant_id: self.config.merchantId,
                pr_page_id_variant: productVariantId,
                REVIEW_DISPLAY_SNAPSHOT_TYPE: self.config.prDisplaySnapshotType,
                on_render: function (config, data) {
                    $.pubsub('publish', 'vfdp.wcs.product_reviews.loaded', {'config':config, 'data':data});
                    if(config.component === 'QuestionDisplay' && qaShowNumberOfQuestions === true ){
                        $qaCta = $('.product-content-info-review-q-and-a-link');
                        $qaCta.html(data.question_count + ' ' + $qaCta.text() );
                    }
                },
                components: {}
            };
        },

        _getPowerReviewsElementConfiguration: function() {
            if (DEBUG) console.log('_getPowerReviewsElementConfiguration');
            var self = this;

            return {
                page_id: self.config.prPageID,
                review_wrapper_url: self.config.writeReviewUrl
            };
        },

        _getPowerReviewsFullviewFeatureConfiguration: function() {
            if (DEBUG) console.log('_getPowerReviewsFullviewFeatureConfiguration');
            var self = this;
            var configFullview = {};

            if (self.config.prFeedlessEnabled) {
                configFullview.product = {
                    name: self.config.productName,
                    url: self.config.canonicalProductURL,
                    image_url: self.config.metaImageURL,
                    description: self.config.productLongDescription,
                    category_name: self.config.seoCategoryName,
                    manufacturer_id: '',
                    upc: self.config.upc,
                    brand_name: self.config.brandStoreName,
                    price: self.config.ogPrice,
                    in_stock: self.config.productPublished
                };
            }

            if (self.config.prDisplay4SnapshotAboveOlapic) {
                configFullview.components = {
                    ReviewList: 'rating_reviews',
                    ReviewSnapshot: 'pr-snapshot-container',
                    ReviewImageDisplay: self.config.prDisplay4IncludeImageDisplay ? 'rating_reviews' : null
                };
            } else {
                configFullview.components = {
                    ReviewDisplay: 'rating_reviews'
                };
            }

            if (self.config.qaEnabled) {
                configFullview.components.QuestionDisplay = 'rating_questions';
            }

            if (self.config.whyDidYouBuyProd) {
                configFullview.components.WhydYouBuyDisplay = 'pr-wyb-display';
            }

            return configFullview;
        },

        _renderPowerReviewsComponents: function() {
            if (DEBUG) console.log('_renderPowerReviewsComponents');
            var self = this;

            require([self.config.prDisplay4URL], function () {
                if (enableProductSchemaInPowerReviewsJSON) {
                  self.powerReviewsConfig[0].subject = productSchema;
                }
                POWERREVIEWS.display.render(self.powerReviewsConfig);
            });
        },

        _renderSizeFitComponent: function () {
            if (DEBUG) console.log('_renderSizeFitComponent');
            var self = this;
            if (self.powerReviewsConfig) {
                var cloneConfig = null;
                if (self.hasFullview === true) {
                    // if there is fullview it's always the first component to be handled
                    cloneConfig = [];
                    cloneConfig[0] = Object.assign({}, self.powerReviewsConfig[0], { components: {
                        SizeFitSnippet: self.powerReviewsConfig[0].components.SizeFitSnippet,
                        ReviewDisplay: null
                    }});
                } else {
                    cloneConfig = Object.assign({}, self.powerReviewsConfig, { components: {
                        SizeFitSnippet: self.powerReviewsConfig.components.SizeFitSnippet,
                        ReviewDisplay: null
                    }});
                }
                if (cloneConfig) {
                    require([self.config.prDisplay4URL], function () {
                        POWERREVIEWS.display.render(cloneConfig);
                    });
                }
            }
        },

        _setReviewSnippetLayout: function(config, data) {
            if (DEBUG) console.log('_setReviewSnippetLayout');
            if (config.component === "ReviewSnippet") {
                var $element = this;

                var $starsContainer = $element.find(".pr-snippet-stars-container");
                var $readAndWriteContainer = $element.find(".pr-snippet-read-and-write");
                var reviewCount = data.review_count;

                if (reviewCount > 0) {
                    $readAndWriteContainer.find(".pr-snippet-write-review-link").addClass("hide");
                } else {
                    $starsContainer.addClass("hide");
                    $readAndWriteContainer.find(".pr-snippet-review-count").addClass("hide");
                }
            }
        },

        initQuestionsAnswers: function() {
            if (DEBUG) console.log('initQuestionsAnswers');
            var self = this;
            POWERREVIEWS.display.productAnswers({
                    write: function (content) {
                        $("div#rating_questions").append(content);
                    }
                },
                {
                    pr_page_id: self.config.prPageID,
                    pr_ask_question: self.config.writeQuestionUrl,
                    pr_answer_question: self.config.writeAnswerUrl
                }
            );
        },

        initWhyDidYouBuy: function() {
            if (DEBUG) console.log('initWhyDidYouBuy');
            var self = this;

            POWERREVIEWS.display.whydYouBuy(document, {
                pr_page_id: self.config.prPageID,
                pr_locale: self.config.prLocale
            });
        },

        /**
         * Binds plugin events
         **/
        events: function() {
            if (DEBUG) console.log('events');
            var self = this;

            // Tabs functionality when tabbed display is enabled
            if (self.config.prTabbedViewEnabled) {
                var tabsContainer = $('.review-tabs-container'),
                    tabReviews = $('#pr-tab-reviews'),
                    tabQA = $('#pr-tab-qa'),
                    tabContentReviews = $('#rating_reviews'),
                    tabContentQA = $('#rating_questions');

                // Future-proof check - hide the tab which is not being served with an 'active' class
                if (tabReviews.hasClass('active')) { tabContentQA.hide(); } else { tabContentReviews.hide(); }

                tabsContainer.on('click', function(e){
                    if (e.target.id === 'pr-tab-reviews') {
                        if (tabQA.hasClass('active')) { tabQA.removeClass('active'); tabContentQA.hide(); }
                        if (!tabReviews.hasClass('active')){ tabReviews.addClass('active'); tabContentReviews.show(); }
                    } else if (e.target.id || e.target.parentNode.id === 'pr-tab-qa') {
                        if (tabReviews.hasClass('active')) { tabReviews.removeClass('active'); tabContentReviews.hide(); }
                        if (!tabQA.hasClass('active')){ tabQA.addClass('active'); tabContentQA.show(); }
                    }
                });
            }
            $.pubsub('subscribe', 'WCS.STL_WIDGET_MODAL.UPDATE_NEW', function(msg, isOpen) {
				stlWidgetModalOpened =  isOpen;
			});

            $.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.FORM_UPDATE', function() {
                if(!stlWidgetModalOpened) {
                    self._renderSizeFitComponent();
                    $.pubsub('publish', 'vfdp.wcs.product_sizefit.refreshed');
                }
			});
        }
    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function(options) {
        return this.each(function() {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if(!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };

});
